export default function reviewRadio() {
  const radios = document.querySelectorAll(".js-radio-reviews");
  radios.forEach((radio) => {
    const input = radio.querySelector("input");
    const svg = radio.querySelector("svg");
    const paths = svg.querySelectorAll("path");

    paths.forEach((path, index) => {
      path.addEventListener("click", () => {
        clearFill(paths);
        changeValue(input, paths, index);
      });
    });
  });

  function changeValue(input, paths, index) {
    let ball = index + 1;
    [...paths]
      .filter((path, i) => index >= i)
      .forEach((path) => (path.style.fill = "#000"));
    input.value = ball;
  }

  function clearFill(paths) {
    paths.forEach((path) => (path.style.fill = ""));
  }
}
